import React from "react";
import { MdOutlineSubscriptions } from "react-icons/md";
import AdminHeader from "../components/Layout/AdminHeader";
import AdminSideBar from "../components/Admin/Layout/AdminSideBar";
import SubscriptionCouponCreationForm from "../components/Admin/SubscriptionCouponForm";
import ManageSubscriptionCoupons from "../components/Admin/SubscriptionCouponList";

const AdminDashboardSubscriptions = () => {
  return (
    <div className="admin-dashboard-container">
      <AdminHeader />
      <div className="admin-dashboard-content">
        <div className="admin-dashboard-wrapper">
          <div className="admin-dashboard-sidebar">
            <AdminSideBar active={12} />
          </div>
          <div className="admin-dashboard-main admin-subscriptions-main admin-page-shell">
            <section className="admin-subscriptions-page" aria-label="Subscription coupon management">
              <header className="admin-page-hero admin-subscriptions-header">
                <div>
                  <p className="admin-page-eyebrow">Super Admin Membership</p>
                  <h1>Subscriptions</h1>
                  <p>Manage subscription coupon codes without changing live plan behavior.</p>
                </div>
                <div className="admin-page-hero-icon" aria-hidden="true">
                  <MdOutlineSubscriptions />
                </div>
              </header>
              <div className="admin-subscriptions-grid">
                <SubscriptionCouponCreationForm />
                <ManageSubscriptionCoupons />
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardSubscriptions;
